import React, { useEffect } from 'react';
import { useForm } from '@mantine/form';
import MantineButton from "../../components/mantine/button";
import { useDispatch, useSelector } from 'react-redux';
import { updateProfile, viewProfile } from '../../store/auth/profile/actions';
import MantineTitle from '../../components/mantine/title';
import MantineContainer from '../../components/mantine/container';
import MantinePaper from '../../components/mantine/paper';
import MantineFlex from '../../components/mantine/flex';
import { useStateContext } from '../../Contexts/ContextProvider';
import UserBio from './UserBio';
import { validateEmail, validateFirstName, validateLastName, validatePhoneNumber } from '../../helpers/common';

const ProfileView = () => {
  const dispatch = useDispatch();
  const { currentPrimaryColor } = useStateContext();
  const Viewprofile = useSelector((state: any) => state.profileData?.viewProfileData?.user);

  const handleResponse = (status: any) => {
    if (status === "SUCCESS") { };
  }
  const form = useForm({
    initialValues: {
      email: '',
      //phoneNumber: '',
      firstName: '',
      clientName: '',
      role: ''
    },
    validate: {
      email: validateEmail,
      //phoneNumber: validatePhoneNumber,
      firstName: validateFirstName,
      clientName: validateLastName,
    },
  });
  const profileData = localStorage.getItem('authUser');
  const profileState = profileData ? JSON.parse(profileData) : null;

  // useEffect(() => {
  //   if (typeof localStorage !== 'undefined') {
  //     const profileData = JSON.parse(localStorage.getItem("authUser") || "{}");
  //     dispatch(viewProfile(profileData?.id, handleResponse));
  //   }
  // }, []);
  
  useEffect(() => {
    if (profileState) {
      form.setValues({
        email: profileState?.email || '',
        role: profileState?.userRole?.roleName || '',
        firstName: profileState?.userName || '',
        clientName: profileState?.client?.name || '',
      });
    }
  }, []);

  const updateprofile = () => { // api triggered in call password change
    form.validate();
    if (form.isValid()) {
      const data = {
        ...form.values,
        "id": profileState?.id,
        "email": form.values.email.toString(),
        //"phoneNumber": form.values.phoneNumber.toString(),
        "firstName": form.values.firstName.toString(),
       // "lastName": form.values.lastName.toString(),
        "userRoleID": profileState?.userRoleID
      }
      dispatch(updateProfile(data))
    }
  }
  return (
    <MantineContainer mt={16} fluid>
      <MantinePaper p={16}>
        <MantineTitle order={4} className="text-start capitalize" ps={12} py={12}>
          Personal Detail
        </MantineTitle>
        <UserBio profileData={profileState} formvalues={form} />
        {/* <MantineFlex justify="flex-start" className="ml-3 pl-1">
          <MantineButton name={'Update'} className={"text-sm font-thin !w-[90px] mr-3"} onClick={() => { updateprofile() }} color={currentPrimaryColor} />
        </MantineFlex> */}
      </MantinePaper>
    </MantineContainer>
  );
};

export default ProfileView;
